import { useCallback, useEffect, useMemo } from "react";

interface UseBlockVertScrollProps {
    resetScroll?: boolean;
    htmlElement: HTMLElement | null;
}

const useBlockVertScroll = ({ resetScroll, htmlElement }: UseBlockVertScrollProps) => {
    const unblockScroll = useCallback(() => {
        if (htmlElement) {
            htmlElement.style.overflowY = "auto";
            htmlElement.style.overflowX = "hidden";
            // WESER-KURIER (2026-08-11, Lasse): auf Android löste das
            // Zurückscrollen am oberen Ende das native Pull-to-Refresh aus →
            // App-Reload. overscroll-behavior auf DEM scrollenden Block-Element
            // (nicht nur auf dem Body) verhindert Scroll-Chaining + das
            // Refresh-Gesture-Affordance direkt an der Quelle. Greift nur, wenn
            // das WebView overscroll-behavior respektiert; eine native
            // SwipeRefreshLayout in der App bliebe davon unberührt (→ App-Seite).
            htmlElement.style.overscrollBehavior = "contain";
        }
    }, [htmlElement]);

    const blockScroll = useCallback(() => {
        if (htmlElement) {
            htmlElement.style.overflowY = "hidden";
            htmlElement.style.overflowX = "hidden";
            if (resetScroll) {
                htmlElement.scrollTo(0, 0);
            }
        }
    }, [htmlElement, resetScroll]);

    useEffect(() => {
        blockScroll();
        return unblockScroll;
    }, [blockScroll, unblockScroll]);

    return useMemo(
        () => ({
            blockScroll,
            unblockScroll,
        }),
        [blockScroll, unblockScroll]
    );
};

export default useBlockVertScroll;
